import { Box, VStack, Text, Spinner, Flex, Avatar, Divider } from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";

function AccountMenu({ onSelect, selectedComponent, savedPropertiesCount, contactedPropertiesCount, savedSearchesCount, loading }) {
  const { locale } = useIntl();
  const isRtl = locale === "ar";
  const auth = JSON.parse(localStorage.getItem("userData"));
  const { profileData } = useSelector((state) => state.user);

  const menuItems = [
    { id: "personalInfo", label: "accountMenu.personalInfo", default: "Personal Information", count: null },
    { id: "contactedProperties", label: "accountMenu.contactedProperties", default: "Contacted properties", count: contactedPropertiesCount },
    { id: "savedProperties", label: "accountMenu.favoriteProperties", default: "Favourite properties", count: savedPropertiesCount },
    { id: "savedSearches", label: "accountMenu.savedSearches", default: "Saved Searches", count: savedSearchesCount },
  ];

  return (
    <Box
      w="100%"
      p="0"
      bg="white"
    >
      {/* User Header */}
      <Flex
        direction="column"
        align="center"
        p={6}
        bgGradient="linear(to-br, gray.50, white)"
        borderBottom="1px solid"
        borderColor="gray.100"
      >
        <Avatar
          size="xl"
          name={profileData?.profileName || profileData?.name || auth?.email}
          mb={3}
          border="4px solid white"
          boxShadow="0 2px 10px rgba(0,0,0,0.1)"
        />
        <Text fontSize="xs" color="gray.500" textAlign="center">
          {profileData?.email || auth?.email}
        </Text>
      </Flex>

      <VStack
        align="stretch"
        spacing="0"
        p={2}
      >
        {menuItems.map((item) => {
          const isActive = selectedComponent === item.id;
          return (
            <Box
              key={item.id}
              as="button"
              onClick={() => onSelect(item.id)}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p="3"
              px={4}
              my={1}
              borderRadius="lg"
              bg={isActive ? "red.50" : "transparent"}
              color={isActive ? "red.600" : "gray.700"}
              _hover={{ bg: isActive ? "red.50" : "gray.50" }}
              transition="all 0.2s"
              position="relative"
            >
              <Flex alignItems="center" gap={2}>
                <Text fontSize="sm" fontWeight={isActive ? "600" : "500"}>
                  <FormattedMessage id={item.label} defaultMessage={item.default} />
                  {item.count !== null && (
                    <Text as="span" ml={1} fontWeight="normal" color={isActive ? "red.400" : "gray.400"}>
                      {loading ? <Spinner size="xs" ml={1} /> : `(${item.count})`}
                    </Text>
                  )}
                </Text>
              </Flex>
              <ChevronRightIcon
                transition="transform 0.2s"
                transform={isActive ? (isRtl ? "rotate(180deg) translateX(4px)" : "translateX(4px)") : ""}
              />
              {isActive && (
                <Box
                  position="absolute"
                  left={isRtl ? "auto" : "0"}
                  right={isRtl ? "0" : "auto"}
                  top="20%"
                  bottom="20%"
                  w="4px"
                  bg="red.500"
                  borderRadius="full"
                />
              )}
            </Box>
          );
        })}
      </VStack>
    </Box>
  );
}

export default AccountMenu;
